// @flow

import * as React from 'react';

import Constants from '../Constants';

const DESIGN_TOP = 217;
const DESIGN_WIDTH = 390;

export const Wagon = (props: { wagon: number, scale: number, soldout: boolean }) => {
  const style = {
    position: 'absolute',
    top: DESIGN_TOP * props.scale,
    width: DESIGN_WIDTH * props.scale,
    left: 0,
    right: 0,
    margin: '0 auto',
  };
  return <img src={Constants.getWagonImage(props.wagon, props.soldout)} style={style} />;
};
